<script setup lang="ts">
import { computed } from 'vue';
import LoadingStatus from '@/assets/js/enum/LoadingStatus';
import InlineLoader from '@/components/general/InlineLoader.vue';

interface Props {
  text?: string;
  icon?: string;
  loaderStatus?: string;
  type?: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  type: 'primary',
  disabled: false,
});

defineEmits<{
  click: [];
}>();

const loading = computed(() => {
  return (
    props.loaderStatus &&
    props.loaderStatus.trim() !== '' &&
    props.loaderStatus !== LoadingStatus.NONE &&
    props.loaderStatus !== LoadingStatus.FAILED
  );
});
</script>

<template>
  <button
    class="uk-button uk-border-rounded"
    :class="{
      [`uk-button-${type}`]: true,
    }"
    :disabled="disabled"
    @click.prevent="loading ? null : $emit('click')"
  >
    <slot></slot>
    <InlineLoader
      :class="{
        'uk-margin-left': icon,
      }"
      :icon="icon"
      :status="loaderStatus"
    />
  </button>
</template>
